import { Button, Icon, InputField, InputToggle, Text } from "@jds/core";
import useInput from "../../../hooks/use-input";
import { validateTextInput } from "../../../util/validation";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const DropDownInputForm = ({
  editData,
  closeModal,
  onSuccess,
  setEditData,
  editSuccess,
}) => {
  const [required, setReqired] = useState(false);
  const [dropDownList, setDropDownList] = useState([""]);

  const {
    value: questionName,
    isValid: isValidQuestion,
    hasError: questionError,
    valueChangeHandler: questionChangeHandler,
    inputBlurHandler: questionBlurHandler,
    reset: resetquestion,
  } = useInput(validateTextInput, {
    type: "text",
    value: editData?.questionName,
  });
  function isArrayUnique(arr) {
    const uniqueSet = new Set(arr);
    return uniqueSet.size === arr.length;
  }
  const allValuesValid = dropDownList.every((item) => item.trim() !== "");
  const unique = isArrayUnique(dropDownList);
  const isValidForm = !isValidQuestion || !allValuesValid || !unique;

  const handleSubmit = () => {
    closeModal();
    if (editData) {
      editSuccess(
        {
          id: uuidv4(),
          type: "dropdown",
          questionName: questionName,
          required: required,
          options: dropDownList,
        },
        editData.index
      );
    } else {
      onSuccess({
        id: uuidv4(),
        type: "dropdown",
        questionName: questionName,
        required: required,
        options: dropDownList,
      });
    }
  };

  useEffect(() => {
    setReqired(editData?.required || false);
    setDropDownList(editData?.options || ["", ""]);
    return () => {
      setEditData(null);
    };
  }, []);

  return (
    <div className="column-form full-width">
      <InputField
        label="Question"
        value={questionName}
        name="Question"
        onChange={questionChangeHandler}
        onBlur={questionBlurHandler}
        state={questionError ? "error" : ""}
        stateText="Question is invalid"
      />
      <Text
        text="Answer List "
        color="primary_grey_80"
        appearance="body-s-bold"
      />
      {dropDownList?.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <input
            style={{
              border: "1px solid black",
              fontSize: "16px",
              padding: "8px",
              borderRadius: "5px",
            }}
            value={item}
            onChange={(e) => {
              setDropDownList((pre) =>
                pre.map((item, i) => {
                  if (i === index) {
                    return e.target.value;
                  } else {
                    return item;
                  }
                })
              );
            }}
          />
          {dropDownList.length > 2 && (
            <Icon
              ic={"IcTrash"}
              onClick={() => {
                setDropDownList((pre) => pre.filter((_, i) => i !== index));
              }}
              color="secondary_50"
            />
          )}
        </div>
      ))}
      {dropDownList.length < 15 && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
          }}
          onClick={() => {
            setDropDownList((pre) => [...pre, ""]);
          }}
        >
          <Icon ic={"ic_add"} />
          <Text
            text={"Add Answer"}
            appearance="body-s-bold"
            color={"primary-50"}
          />
        </div>
      )}

      <InputToggle
        type="toggle"
        label="Required"
        name="reqired"
        size="small"
        checked={required}
        onChange={(e) => {
          setReqired(e.target.checked);
        }}
      ></InputToggle>
      <Button
        fullWidth
        disabled={isValidForm}
        type="submit"
        label="Add"
        size="large"
        onClick={handleSubmit}
      />
    </div>
  );
};

export default DropDownInputForm;
